import { INTERNSHIP_APP_API } from '../Config/config';

const getWorkLogEntriesApi = (WorkLogId: string | number): string => {
  return `${INTERNSHIP_APP_API}/worklogs/${WorkLogId}/entries`;
};

const getRejectNoteApi = (
  WorkLogId: string | number,
  entryId: string | number
): string => {
  return `${INTERNSHIP_APP_API}/worklogs/${WorkLogId}/entries/${entryId}/reject-note`;
};

const createEntryApi = (WorkLogId: string | number): string => {
  return `${INTERNSHIP_APP_API}/worklogs/${WorkLogId}/entries`;
};

const deleteEntryApi = (
  WorkLogId: string | number,
  entryId: React.Key
): string => {
  return `${INTERNSHIP_APP_API}/worklogs/${WorkLogId}/entries/${entryId}`;
};

const updateEntryApi = (
  WorkLogId: string | number,
  entryId: React.Key
): string => {
  return `${INTERNSHIP_APP_API}/worklogs/${WorkLogId}/entries/${entryId}`;
};

const finalizeWorkLogApi = (
  studentId: string | number,
  processId: string | number
): string => {
  return `${INTERNSHIP_APP_API}/students/${studentId}/internship-processes/${processId}/worklogs/finalize`;
};

export {
  getWorkLogEntriesApi,
  getRejectNoteApi,
  createEntryApi,
  deleteEntryApi,
  updateEntryApi,
  finalizeWorkLogApi,
};
